export enum AircraftTypeEnum {
  FF = 'FF',
  NB = 'NB',
  WB = 'WB',
}
